function FeaturedIcon({
  icon,
  variant = 'default',
}: {
  icon: React.ReactNode;
  variant?: 'default' | 'error' | 'warning' | 'success' | 'info';
} & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="featured-icon"
      data-variant={variant}
      className="group/featured-icon flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full border-7 data-[variant=default]:border-ui-selected data-[variant=error]:border-error-main/20 data-[variant=info]:border-info-main/20 data-[variant=success]:border-success-main/20 data-[variant=warning]:border-warning-main/20"
    >
      <div className="flex size-6.5 shrink-0 items-center justify-center rounded-full border border-secondary-dark fill-secondary-dark group-data-[variant=error]/featured-icon:border-error-main group-data-[variant=error]/featured-icon:fill-error-main group-data-[variant=info]/featured-icon:border-info-main group-data-[variant=info]/featured-icon:fill-info-main group-data-[variant=success]/featured-icon:border-success-main group-data-[variant=success]/featured-icon:fill-success-main group-data-[variant=warning]/featured-icon:border-warning-main group-data-[variant=warning]/featured-icon:fill-warning-main">
        {icon}
      </div>
    </div>
  );
}

export { FeaturedIcon };
